import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import React from 'react';
import { HeadCell, Order } from '../util/tableUtil';
import LargeCenterSpinner from './LargeCenterSpinner';

interface EnhancedTableProps {
	headCells: HeadCell[];
	onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
	order: Order;
	orderBy: string;
}

function EnhancedTableHead(props: EnhancedTableProps) {
	const { headCells, order, orderBy, onRequestSort } = props;
	const createSortHandler =
		(property: string) => (event: React.MouseEvent<unknown>) => {
			onRequestSort(event, property);
		};

	return (
		<TableHead>
			<TableRow>
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						sortDirection={orderBy === headCell.id ? order : false}
						align={headCell.rightAlign ? 'right' : 'left'}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : 'asc'}
							onClick={createSortHandler(headCell.id)}
						>
							{headCell.label}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

interface SortableTableProps {
	rows: any;
	headCells: HeadCell[];
	additionalMsg: any;
	order: Order;
	loading?: boolean;
	setOrder: (order: Order) => void;
	orderBy: string;
	setOrderBy: (orderBy: string) => void;
}

export default function SortableTable(props: SortableTableProps) {
	const {
		rows,
		headCells,
		additionalMsg,
		order,
		loading,
		setOrder,
		orderBy,
		setOrderBy,
	} = props;

	const handleRequestSort = (
		event: React.MouseEvent<unknown>,
		property: string,
	) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	return (
		<div>
			<TableContainer>
				<Table
					aria-labelledby='tableTitle'
					size={'small'}
					aria-label='enhanced table'
				>
					<EnhancedTableHead
						headCells={headCells}
						order={order}
						orderBy={orderBy}
						onRequestSort={handleRequestSort}
					/>
					<TableBody>{loading ? <LargeCenterSpinner /> : rows}</TableBody>
				</Table>
			</TableContainer>
			{additionalMsg}
		</div>
	);
}
